import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTimeout } from "../../components/Common";
import { API_BASE } from "../../AppConfig";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";

import { blue } from "@material-ui/core/colors";

import {
    UPDATE_QUOTE_PARAMETERS,
    updateJobState,
    updateJobParameter,
    addNote,
    updateJobHistory,
} from "../../redux_store/jobState";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";
import BSL_Button from "../../components/BSL_Button";
import { addNewHistoryLine } from "../../helper/Helper";
const { convertJobStateToIni } = require("../../components/Common_Conversions");

const emails = ["username@gmail.com", "user02@gmail.com"];
const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});

//DES-1085 - Order list was mixed in Lyves before
function sortedList(material_list) {
    const list = [material_list.items];
    const dictionary = [
        "STEEL ROOFING",
        "POLYCARBONATE ROOFING",
        "FIBREGLASS ROOFING",
        "BACK CHANNEL",
        "GUTTERS & ACCESSORIES",
        "DOWNPIPES & ACCESSORIES",
        "FLASHING",
        "BEAMS",
        "POSTS",
        "POSTS & ACCESSORIES",
        "BRACKETS",
        "CONNECTORS",
        "HARDWARE",
        "MISCELLANEOUS ITEMS",
    ];

    const tempMatList = [];
    for (let i = 0; i < dictionary.length; i++) {
        for (let iter2 = 0; iter2 < Object.keys(list[0]).length; iter2++) {
            if (String(list[0][iter2].Category).toUpperCase() == dictionary[i].toUpperCase()) {
                tempMatList.push(list[0][iter2]);
            }
        }
    }

    // KC added, if item does not match a category, add it at the end...
    for (let iter2 = 0; iter2 < Object.keys(list[0]).length; iter2++) {
        if (!dictionary.includes(String(list[0][iter2].Category).toUpperCase())) {
            console.log("Category " + list[0][iter2].Category + " not found");
            tempMatList.push(list[0][iter2]);
        }
    }

    return tempMatList;
}

export default function Dialog_SendToLyves(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { onClose, selectedValue, open } = props;

    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    const user = useSelector((state) => state.app.user);
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);

    const [ordering, setOrdering] = React.useState(false);
    const [allowLyves, setAllowLyves] = React.useState(false);

    let has_BOM_data = job?.QuoteParameters?.BOM?.SystemList?.total_price;

    const handleClose = () => {
        onClose(selectedValue);
        setAllowLyves(false);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    React.useEffect(() => {
        if (open && !has_BOM_data) {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "There appears to be no BOM data for this job. You will not be able to order this job.",
            });
        }
    }, [open]);

    const getCSV = (type = "CSV", sit = false) => {
        if (ordering) return;
        if (!job) {
            console.log("no job to save...", job);
            return;
        }

        setOrdering(type);

        let csv_url = API_BASE() + "lyves/" + btoa(logged_user_code) + "/" + type;
        if (sit) {
            csv_url = API_BASE() + "SITLyves/" + btoa(logged_user_code) + "/" + type;
        }

        console.log("CREATING " + type + "...");

        let job_ini = convertJobStateToIni(job, app, "", config);

        let material_list = job?.QuoteParameters?.BOM?.OrderList;
        if (!material_list || !material_list?.items) material_list = job?.QuoteParameters?.BOM?.SystemList;

        material_list.items = sortedList(material_list);

        let history = job?.History || [];
        let newHistory = addNewHistoryLine({
            jobState: { history },
            historyLine: { "GS1 Update": type },
        });
        if (newHistory?.length > 0) history.push(newHistory[0]);

        let job_id = job?.id;
        let business_code = job?.BusinessCode;
        dispatch(updateJobHistory({ business_code, job_id, new_history: history }));

        return (
            fetchTimeout(
                csv_url,
                {
                    method: "POST", // *GET, POST, PUT, DELETE, etc.
                    body: JSON.stringify({
                        job_raw: job,
                        job: job_ini,
                        order_list: material_list,
                        user: user,
                    }), // body data type must match "Content-Type" header
                },
                material_list?.items?.length > 500 ? 90000 : 45000
            )
                // .then(async response => {let new_response = {text: await response.text()}; return new_response})
                .then(async (response) => {
                    setOrdering(false);
                    if (response.status === 422) {
                        console.log("process " + type);
                    } else if (response.status >= 200 && response.status < 300) {
                        console.log("created");
                        let response_text = await response.text();

                        if (type === "CSV" || type === "DownloadGS1" || window.debug) {
                            var element = document.createElement("a");
                            element.setAttribute(
                                "href",
                                "data:text/plain;charset=utf-8," + encodeURIComponent(response_text)
                            );
                            element.setAttribute("download", job.id + "_LYVES." + (type === "CSV" ? "CSV" : "GS1"));

                            element.style.display = "none";
                            document.body.appendChild(element);

                            element.click();

                            document.body.removeChild(element);
                            dispatch(
                                addNote(
                                    true,
                                    user,
                                    "Order Accepted and Processed Manually (" + (type === "CSV" ? "CSV" : "GS1") + ")"
                                )
                            );

                            dispatch({
                                type: SHOW_DESIGNER_MESSAGE,
                                message:
                                    "downloading a GS1 or CSV file will not update the job status. If you wish to change the status, please do so manually",
                            });
                        } else if (type === "GS1") {
                            dispatch(
                                updateJobParameter(null, {
                                    Status: "Ordered",
                                    OrderStatus: "Accepted",
                                })
                            );
                            //DES-1147 - Successful pop changed to green
                            dispatch({
                                type: SHOW_DESIGNER_MESSAGE,
                                message: {
                                    type: "Success",
                                    message: response_text,
                                },
                            });
                            dispatch(addNote(true, user, "Order Accepted and Processed (GS1)"));
                        }
                        handleClose();
                    } else {
                        setOrdering(false);
                        let response_text = await response.text();
                        console.log("ERROR CREATING " + type);
                        console.log("ERROR " + response_text);

                        dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: response_text,
                        });
                    }
                })
                .catch((e) => {
                    setOrdering(false);
                    console.log("ERROR " + type, e);
                    // handle errors and timeout error
                })
        ); // parses JSON response into native Javascript objects
    };

    if (["ACCEPTED"].includes(job?.OrderStatus) && !allowLyves) {
        return (
            open && (
                <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle id="simple-dialog-title">
                        Job has already been sent to Lyves, this will result in additional order for same job in Lyves,
                        do you want to continue?
                    </DialogTitle>
                    <br />
                    <List style={{ display: "flex", justifyContent: "center" }}>
                        <BSL_Button secondary style={{ marginRight: "10px" }} onClick={handleClose}>
                            Cancel
                        </BSL_Button>
                        <BSL_Button style={{ marginLeft: "10px" }} onClick={() => setAllowLyves(true)}>
                            OK
                        </BSL_Button>
                    </List>
                </Dialog>
            )
        );
    } else
        return (
            <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                <DialogTitle id="simple-dialog-title">
                    Send Job To Lyves{window.test ? " (TEST)" : ""}
                    {window.debug ? " (DEBUG)" : ""}
                </DialogTitle>
                <List>
                    Confirm Delivery Date
                    <br />
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        value={job?.QuoteParameters?.DeliveryDate}
                        onChange={(date) => {
                            dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "DeliveryDate", date));
                        }}
                    />
                    {((user?.id.includes("diego.portela@") && window.debug) || window.location.href.includes("sit.")) && (
                        <ListItem button disabled={ordering || !has_BOM_data} onClick={() => getCSV("GS1", true)}>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    {ordering === "GS1" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                    <div
                                        style={{
                                            position: "absolute",
                                        }}
                                    >
                                        <CreateNewFolderIcon />
                                    </div>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Send Job Directly To Lyves (GS1) - SIT" />
                        </ListItem>
                    )}
                    <ListItem button disabled={ordering || !has_BOM_data} onClick={() => getCSV("GS1")}>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                {ordering === "GS1" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                <div
                                    style={{
                                        position: "absolute",
                                    }}
                                >
                                    <CreateNewFolderIcon />
                                </div>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Send Job Directly To Lyves (GS1)" />
                    </ListItem>
                    {((user?.id.includes("diego.portela@") && window.debug) ||
                        (window.location.href.includes("sit.") && user?.Role === 99)) && (
                        <ListItem button disabled={ordering || !has_BOM_data} onClick={() => getCSV("CSV", true)}>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    {ordering === "CSV" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                    <div
                                        style={{
                                            position: "absolute",
                                        }}
                                    >
                                        <CreateNewFolderIcon />
                                    </div>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Download CSV File (manual processing) - SIT" />
                        </ListItem>
                    )}
                    {user?.Role === 99 && (
                        <ListItem button disabled={ordering || !has_BOM_data} onClick={() => getCSV()}>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    {ordering === "CSV" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                    <div
                                        style={{
                                            position: "absolute",
                                        }}
                                    >
                                        <CreateNewFolderIcon />
                                    </div>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Download CSV File (manual processing)" />
                        </ListItem>
                    )}
                    {((user?.id.includes("diego.portela@") && window.debug) || window.location.href.includes("sit.")) && (
                        <ListItem
                            button
                            disabled={ordering || !has_BOM_data}
                            onClick={() => getCSV("DownloadGS1", true)}
                        >
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    {ordering === "GS1" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                    <div
                                        style={{
                                            position: "absolute",
                                        }}
                                    >
                                        <CreateNewFolderIcon />
                                    </div>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Download GS1 File - SIT" />
                        </ListItem>
                    )}
                    <ListItem button disabled={ordering || !has_BOM_data} onClick={() => getCSV("DownloadGS1")}>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                {ordering === "GS1" ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                <div
                                    style={{
                                        position: "absolute",
                                    }}
                                >
                                    <CreateNewFolderIcon />
                                </div>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Download GS1 File" />
                    </ListItem>
                    {/* <ListItem button>
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
                <FileCopyIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="... Clone current Job." />
          </ListItem>
          <ListItem button>
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
                <PeopleIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="... with current Customer Job Details." />
          </ListItem> */}
                </List>
            </Dialog>
        );
}

Dialog_SendToLyves.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
